import AppHeader from '../AppHeader'

export default {
  name: 'master',
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    isMachineOrderAdmin () {
      return window.localStorage.getItem('machine_order_type') === 'admin'
    }
  },
  components: {
    AppHeader
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master.js